import { CommonModule, CurrencyPipe, NgClass } from '@angular/common'
import { Component, inject, input, OnDestroy, output } from '@angular/core'
import { AuthService } from '@app/modules/auth/services/auth.service'
import { WorkspaceRoleService } from '@app/modules/auth/services/workspace-role.service'
import { V2TranslationService } from '@app/v2/services/translation.service'
import { CurrencyShortHandPipe } from '@app/v2/shared/pipes/currency-short-hand.pipe'
import { TranslateModule } from '@ngx-translate/core'
import { NgxTippyModule } from 'ngx-tippy-wrapper'
import { Subject } from 'rxjs'

@Component({
  selector: 'app-go-to-billing-card',
  imports: [CurrencyShortHandPipe, NgClass, NgxTippyModule, TranslateModule, CurrencyPipe, CommonModule],
  standalone: true,
  templateUrl: './go-to-billing-card.component.html'
})
export class GoToBillingCardComponent implements OnDestroy {
  private _auth = inject(AuthService)
  private _workspaceRole = inject(WorkspaceRoleService)
  private destroy$ = new Subject<void>()

  public balance = input<number | null>(null)
  public isBalanceLoaded = input<boolean>(false)

  private _v2TranslationService = inject(V2TranslationService)
  isClicked = output<void>()
  get isRtl(): boolean {
    return this._v2TranslationService.currentLang()?.direction === 'rtl'
  }
  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  /**
   * Open organization settings on the billing section.
   */
  public canNavigateToBilling(): boolean {
    return this._workspaceRole.canAccessBilling() && this._workspaceRole.canAccessWorkspaceSettings()
  }

  /**
   * Open organization settings on the billing section.
   * For viewer roles (no org-settings access), this is a no-op.
   */
  navigateToBilling() {
    if (!this.canNavigateToBilling()) return
    this.isClicked.emit()
    this._auth.navigateToPage('billing')
  }
}
